import { translate } from 'internal/translate'

const translations = {
  en: {
    auth: {
      register: {
        success: 'You are now registered and logged in.',
        error: 'An error occurred. Please try again later.',
      },
      password: {
        restore: {
          success: 'Your password is saved and you are logged in.',
          error: 'An error occurred while saving the password.',
        },
      },
    },
    footer: {
      aBrandOf: 'A brand of',
      contact: 'Contact',
      ourBrands: 'Our brand',
      socialTitle: 'Become our friend',
      languageTitle: 'Language',
      countriesTitle: 'Countries',
      awardsTitle: 'Distinguished',
      shippingTitle: 'Shipping',
      paymentTitle: 'Payments',
    },
    validation: {
      tooSmall: 'at least {missing} characters are missing',
      tooBig: 'a maximum of {max} characters are allowed',
      email: 'please enter a valid email address',
      required: 'the field must not be empty',

      return: {
        product: {
          noSelected:
            'please select the items to return to complete the process.',
        },
        batteryPackaging:
          'To continue, confirm that you have read and understood the status of the batteries.',
      },

      auth: {
        registration: {
          accountExists: 'an account with this email address already exists',
          privatePolicy: 'please agree to the privacy policy',
        },
        migration: {
          accountNotFound:
            'There is no customer account with this email address',
        },
      },
    },
    unit: {
      weight: 'Gram',
    },
    deliveryTime: 'Delivery Time',
  },
  de: {
    auth: {
      register: {
        success: 'Du bist jetzt registriert und eingeloggt.',
        error: 'Ein Fehler ist aufgetreten. Bitte versuche es später erneut.',
      },
      password: {
        restore: {
          success: 'Dein Passwort ist gespeichert und du bist angemeldet.',
          error: 'Beim Speichern des Passworts ist ein Fehler aufgetreten.',
        },
      },
    },
    footer: {
      aBrandOf: 'Eine Marke von',
      contact: 'Kontakt',
      ourBrands: 'Unsere Marken',
      socialTitle: 'Werde unser Freund',
      languageTitle: 'Sprache',
      countriesTitle: 'Länder',
      awardsTitle: 'Ausgezeichnet',
      shippingTitle: 'Versand',
      paymentTitle: 'Zahlung',
    },
    validation: {
      tooSmall: 'es fehlen noch mindestens {missing} Zeichen',
      tooBig: 'es sind maximal {max} Zeichen erlaubt',
      email: 'bitte gib eine gültige E-Mail Adresse ein',
      required: 'das Feld darf nicht leer sein',

      return: {
        product: {
          noSelected:
            'bitte wähle Artikel zur Retoure aus, um die Retoure abzuschließen.',
        },

        batteryPackaging:
          'Um fortzufahren, bestätige die Kenntnisnahme und den Zustand der Batterien.',
      },

      auth: {
        registration: {
          accountExists: 'es gibt bereits ein Konto mit dieser E-Mail-Adresse',
          privatePolicy: 'bitte stimme den Datenschutzbestimmungen zu',
        },
        migration: {
          accountNotFound:
            'Es existiert kein Kundenkonto mit dieser E-Mail-Adresse',
        },
      },
    },
    unit: {
      weight: 'Gramm',
    },
    deliveryTime: 'Lieferzeit',
  },
  fr: {
    footer: {
      aBrandOf: 'Une marque de',
      contact: 'Contact',
      ourBrands: 'Notre marque',
      socialTitle: 'Devient mon ami',
      languageTitle: 'Langue',
      countriesTitle: 'Pays',
      awardsTitle: 'Excellent',
      shippingTitle: 'Expédition',
      paymentTitle: 'Paiement',
    },
    validation: {
      tooSmall: 'il manque encore {missing} caractères',
      tooBig: 'un maximum de {max} caractères est autorisé',
      email: 'veuillez saisir une adresse e-mail valide',
      required: 'le champ ne doit pas être vide',

      return: {
        product: {
          noSelected:
            'veuillez sélectionner des articles à retourner pour finaliser le retour.',
        },

        batteryPackaging:
          "Pour continuer, confirme la prise de connaissance et l'état des piles.",
      },

      auth: {
        registration: {
          accountExists: 'un compte avec cette adresse e-mail existe déjà',
          privatePolicy: 'veuillez accepter la politique de confidentialité',
        },
        migration: {
          accountNotFound:
            "Il n'existe pas de compte client avec cette adresse e-mail",
        },
      },
    },
    auth: {
      register: {
        success: 'Vous êtes maintenant inscrit et connecté.',
        error: 'Une erreur est survenue. Veuillez réessayer plus tard.',
      },
      password: {
        restore: {
          success: 'Votre mot de passe est enregistré et vous êtes connecté.',
          error:
            "Une erreur s'est produite lors de l'enregistrement du mot de passe.",
        },
      },
    },
    unit: {
      weight: 'grammes',
    },
    deliveryTime: 'Délai de livraison',
  },
  it: {
    footer: {
      aBrandOf: 'Un marchio di',
      contact: 'Contattateci',
      ourBrands: 'Il nostro marchio',
      socialTitle: 'Diventa nostro amico',
      languageTitle: 'Lingua',
      countriesTitle: 'Paesi',
      awardsTitle: 'Eccellente',
      shippingTitle: 'Shipping',
      paymentTitle: 'Pagamento',
    },
    validation: {
      tooSmall: 'mancano ancora {missing} caratteri',
      tooBig: 'sono ammessi al massimo {max} caratteri',
      email: 'inserisci un indirizzo email valido',
      required: 'il campo non deve essere vuoto',

      return: {
        product: {
          noSelected:
            'seleziona gli articoli da restituire per completare il reso',
        },

        batteryPackaging:
          'Per continuare, confermare di aver letto e compreso lo stato delle batterie.',
      },

      auth: {
        registration: {
          accountExists: 'esiste già un account con questo indirizzo email',
          privatePolicy: "si prega di accettare l'informativa sulla privacy",
        },
        migration: {
          accountNotFound:
            'Non esiste un account cliente con questo indirizzo email',
        },
      },
    },
    auth: {
      register: {
        success: 'Ora sei registrato e connesso.',
        error: 'Si è verificato un errore. Riprova più tardi.',
      },
      password: {
        restore: {
          success: 'La tua password è stata salvata e sei connesso.',
          error:
            'Si è verificato un errore durante il salvataggio della password.',
        },
      },
    },
    unit: {
      weight: 'Grammi',
    },
    deliveryTime: 'Data di consegna',
  },
  da: {
    footer: {
      aBrandOf: 'Et brand af',
      contact: 'Kontakt',
      ourBrands: 'Vores brand',
      socialTitle: 'Blive vores venner',
      languageTitle: 'Sprog',
      countriesTitle: 'Lande',
      awardsTitle: 'Prisvindende',
      shippingTitle: 'Forsendelse',
      paymentTitle: 'Betalinger',
    },
    validation: {
      tooSmall: 'der mangler stadig {missing} tegn',
      tooBig: 'der er tilladt højst {max} tegn',
      email: 'venligst indtast en gyldig e-mailadresse',
      required: 'feltet må ikke være tomt',

      return: {
        product: {
          noSelected:
            'venligst vælg varer til returnering for at fuldføre returneringen.',
        },

        batteryPackaging:
          'For at fortsætte, bekræft, at du har læst og forstået batteri status.',
      },

      auth: {
        registration: {
          accountExists:
            'der findes allerede en konto med denne e-mail-adresse',
          privatePolicy: 'venligst accepter privatlivspolitikken',
        },
        migration: {
          accountNotFound:
            'Der findes ingen kundekonto med denne e-mail-adresse',
        },
      },
    },
    auth: {
      register: {
        success: 'Du er nu registreret og logget ind.',
        error: 'Der opstod en fejl. Prøv venligst igen senere.',
      },
      password: {
        restore: {
          success: 'Din adgangskode er gemt, og du er logget ind.',
          error: 'Der opstod en fejl under lagring af adgangskoden.',
        },
      },
    },
    unit: {
      weight: 'Gram',
    },
    deliveryTime: 'Leveringstid',
  },
  es: {
    footer: {
      aBrandOf: 'Una marca de',
      contact: 'Contacto',
      ourBrands: 'Nuestra marca',
      socialTitle: 'Hazte amigo nuestro',
      languageTitle: 'Idioma',
      countriesTitle: 'Países',
      awardsTitle: 'Premios',
      shippingTitle: 'Envío',
      paymentTitle: 'Método de pago',
    },
    validation: {
      tooSmall: 'faltan {missing} caracteres',
      tooBig: 'se permiten un máximo de {max} caracteres',
      email: 'por favor, introduce un email válido.',
      required: 'el campo no debe estar vacío',

      return: {
        product: {
          noSelected:
            'por favor, selecciona artículos para devolver para completar la devolución.',
        },

        batteryPackaging:
          'Para continuar, confirma que has leído y entendido el estado de las baterías.',
      },

      auth: {
        registration: {
          accountExists:
            'ya existe una cuenta con esta dirección de correo electrónico',
          privatePolicy: 'por favor, acepta la política de privacidad',
        },
        migration: {
          accountNotFound:
            'No existe una cuenta de cliente con esta dirección de correo electrónico',
        },
      },
    },
    auth: {
      register: {
        success: 'Ahora estás registrado e iniciado sesión.',
        error: 'Ha ocurrido un error. Por favor, inténtalo de nuevo más tarde.',
      },
      password: {
        restore: {
          success: 'Tu contraseña se ha guardado y estás conectado.',
          error: 'Se produjo un error al guardar la contraseña.',
        },
      },
    },
    unit: {
      weight: 'Gramo',
    },
    deliveryTime: 'Plazo de entrega',
  },
}

export const t = (term: string, props: Record<string, string> = {}) =>
  translate(translations, term, props)
